import React, { useEffect, useState } from 'react';
import moment from 'moment';
import UserService from '../../../helpers/User';

const SidebarFooter = ({ userName, userRole }) => {
	const [time, setTime] = useState(moment());

	useEffect(() => {
		const interval = setInterval(() => { setTime(moment()); }, 1000);

		return () => { clearInterval(interval); };
	}, []);

	return (
		<div className="sidebar-footer">
			<div className="sidebar-footer-identity">
				{userName && <div className="sidebar-footer-name" title={userName}>{userName}</div>}
				{userRole && <div className="sidebar-footer-subtitle">{UserService.toUppercaseUserRole(userRole)}</div>}
			</div>

			<time className="sidebar-footer-time" dateTime={time.format()}>{time.format('HH:mm')}</time>
		</div>
	);
};

export default SidebarFooter;
